// src/components/info/InfoSection.js
import React from 'react';
import './InfoSection.css';
import './MobileInfoSection.css';

const InfoSection = () => {
  return (
    <section className="info-section">
      <div className="info-container">
        {/* Frame 124 + Frame 123 */}
        <h2 className="info-title">
          <span className="question-icon">Q</span> 生活保護とは？
        </h2>
        
        {/* Desktop content - Frame 125 */}
        <div className="info-content desktop-only">
          <p className="info-text">
            生活保護とは、健康で文化的な最低限度の生活を保障するために、生活困窮者に対して
            <span className="info-orange-text">最低限の生活費を支給しながら生活における様々な支援を行う</span>
            ことです。そのうえで、生活保護受給者が経済的に自立することができる仕組みを構築しているのが生活保護制度です。
          </p>
        </div>
        
        {/* Mobile content - separate for better control */}
        <div className="info-content mobile-info-content">
          <p className="info-text">
            生活保護とは、健康で文化的な最低限度の生活を保障するために、生活困窮者に対して
            <span className="info-orange-text">最低限の生活費を支給しながら生活における様々な支援を行う</span>
            ことです。そのうえで、生活保護受給者が経済的に自立することができる仕組みを構築しているのが生活保護制度です。
          </p>
          
        </div>
        
        {/* Desktop eligibility - Frame 126 */}
        <div className="eligibility-container desktop-only">
          <p className="eligibility-text">
            以下の<span className="info-orange-text">どこでも当てはまる方</span>は生活保護を受け取れる可能性が高いです！
          </p>
          
          {/* Frame 122 - eligibility-boxes */}
          <div className="eligibility-boxes">
            <div className="eligibility-box">
              <p className="box-text">世帯収入が<br />最低生活費を下回る</p>
            </div>
            <div className="eligibility-box">
              <p className="box-text">家族などの身内から<br /><span className="yellow-highlight">支援</span>を受けられない</p>
            </div>
            <div className="eligibility-box">
              <p className="box-text"><span className="yellow-highlight">病気やケガ</span>に<br />よって働けない</p>
            </div>
            <div className="eligibility-box">
              <p className="box-text"><span className="yellow-highlight">預貯金や資産</span>が<br />ほとんどない</p>
            </div>
          </div>
        </div>
        
        {/* Mobile eligibility - separate for better control */}
        <div className="eligibility-container mobile-eligibility-container">
          <p className="eligibility-text">
            以下の<span className="info-orange-text">どこでも当てはまる方</span>は生活保護を受け取れる可能性が高いです！
          </p>
          
          <div className="eligibility-boxes">
            <div className="eligibility-box">
              <p className="box-text">世帯収入が<br />最低生活費を下回る</p>
            </div>
            <div className="eligibility-box">
              <p className="box-text">家族などの身内から<br /><span className="yellow-highlight">支援</span>を受けられない</p>
            </div>
            <div className="eligibility-box">
              <p className="box-text"><span className="yellow-highlight">病気やケガ</span>に<br />よって働けない</p>
            </div>
            <div className="eligibility-box">
              <p className="box-text"><span className="yellow-highlight">預貯金や資産</span>が<br />ほとんどない</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;